import { required, minValue, maxValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a receipt name.'), required)
      },
      description: {
      },
      is_active: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      is_confidential: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      },
      inputs: {
        required: helpers.withMessage(i18n.global.t('Please add at least one input.'), required)
      },
      outputs: {
        required: helpers.withMessage(i18n.global.t('Please add at least one output.'), required)
      },
      cost_allocation: {
        minValue: helpers.withMessage(i18n.global.t('Total cost allocation must be 100%.'), minValue(100)),
        maxValue: helpers.withMessage(i18n.global.t('Total cost allocation must be 100%.'), maxValue(100)),
      }
    }
  }
};
